import XLSX from 'xlsx'

import DataLoading from "./DataLoading"
import { MARKERS_KEYS } from './ids'

class Marker {
  id
  x
  y
  categs = []
  indicators = []
  custom_content_id = []

  constructor(jsonMarker) {
    this.id = jsonMarker.id
    this.x  = jsonMarker.x_pos
    this.y  = jsonMarker.y_pos
  }

}



class MarkersPool {
  all = []


  init() {
    let json = DataLoading.markers


    let currentMarker = null

    json.forEach(jsonMarker => {
      let markerId = jsonMarker.id

      if(markerId) {
        // ligne avec une id : on push l'ancien marker
        if (currentMarker) this.all.push(currentMarker)

        // et on en crée un nouveau
        currentMarker = new Marker(jsonMarker)
      }

      let indicators = jsonMarker.indicators ? jsonMarker.indicators.split(";") : []
      currentMarker.indicators.push(indicators)

      let custom_content = jsonMarker.custom_content_id
      currentMarker.custom_content_id.push(custom_content)

      let categ = jsonMarker.aep_categories
      if(categ) currentMarker.categs.push(categ)
    })
    if (currentMarker) this.all.push(currentMarker) // on push le dernier marker
  }
}

export default new MarkersPool()
